import { required, numeric, requiredIf, email} from '@vuelidate/validators';

export function overrideDefaultValidatorsMessage(){
    required.$message = "Обязательное поле";
    numeric.$message = "Значение должно быть числовое";
    email.$message = "Введите корректный email"
}